var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#26436E",
    fillRule: "nonzero",
    points: "10 19 10 17.195 4.312 17.195 4.312 13.114 9.642 13.114 9.642 11.335 4.312 11.335 4.312 7.796 10 7.796 10 6 2 6 2 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26436E",
    fillRule: "nonzero",
    d: "M13.7816092,19 L13.7816092,12.2421341 C13.7816092,11.3292294 13.743295,10.3214774 13.6666667,9.21887825 L13.6666667,9.21887825 L13.6256158,8.64090287 L13.6912972,8.64090287 L19.5944171,19 L22,19 L22,6 L20.2019704,6 L20.2019704,12.8112175 C20.2019704,13.2913817 20.2183908,13.9597583 20.2512315,14.8163475 C20.2840722,15.6729366 20.3059661,16.1694026 20.316913,16.3057456 L20.316913,16.3057456 L20.2676519,16.3057456 L14.3809524,6 L12,6 L12,19 L13.7816092,19 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.b92eac800f91e941c7ab6208954d0c93.svg";
export { ForwardRef as ReactComponent };